import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  text?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  className = '',
  text,
}) => {
  const dims = { sm: 16, md: 32, lg: 48 }[size];

  return (
    <div
      className={className}
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '0.625rem' }}
    >
      <svg
        width={dims}
        height={dims}
        viewBox="0 0 32 32"
        fill="none"
        role="status"
        aria-label="Loading"
        data-testid="loading-spinner"
        style={{ animation: 'spin 0.75s linear infinite', flexShrink: 0 }}
      >
        <circle cx="16" cy="16" r="13" stroke="#1e2d45" strokeWidth="3" />
        <path d="M3 16a13 13 0 0113-13" stroke="#3b82f6" strokeWidth="3" strokeLinecap="round" />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </svg>
      {text && (
        <p style={{ fontSize: '0.8125rem', color: '#64748b', fontWeight: 500 }}>{text}</p>
      )}
    </div>
  );
};
